import { FC, ReactElement, useEffect, useState } from 'react';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { NAVIGATION_BAR_ITEM_ID, PLAY_BUTTON_ID, useVisualViewportResize } from '@whitesharx/starfall-frontend-core';
import { createPopup } from './utils';
import { highlightedStyles } from './styles.css';
import { useEvent } from '~/src/hooks/useEvent';

type Props = {
  step: number;
  completeStep: () => void;
};

const DesktopTutorial: FC<Props> = ({ step, completeStep }) => {
  const [content, setContent] = useState<ReactElement | null>(null);

  const drawFirstStep = () => {
    const challenges = document.getElementById(NAVIGATION_BAR_ITEM_ID.challenges);
    const learn = document.getElementById(NAVIGATION_BAR_ITEM_ID.learn);

    if (!challenges || !learn) {
      completeStep();

      return;
    }
    challenges.classList.add(highlightedStyles);
    learn.classList.add(highlightedStyles);

    setContent(
      <>
        {createPopup(t('web-tutorial.challenges'), challenges, 'left')}
        {createPopup(t('web-tutorial.learn'), learn, 'left')}
      </>
    );
  };

  const drawSecondStep = () => {
    document.getElementById(NAVIGATION_BAR_ITEM_ID.challenges)?.classList.remove(highlightedStyles);
    document.getElementById(NAVIGATION_BAR_ITEM_ID.learn)?.classList.remove(highlightedStyles);
    const ranking = document.getElementById(NAVIGATION_BAR_ITEM_ID.ranking);

    if (!ranking) {
      completeStep();
      return;
    }

    ranking.classList.add(highlightedStyles);

    setContent(createPopup(t('web-tutorial.ranking'), ranking, 'left'));
  };

  const drawThirdStep = () => {
    document.getElementById(NAVIGATION_BAR_ITEM_ID.ranking)?.classList.remove(highlightedStyles);
    const playNav = document.getElementById(NAVIGATION_BAR_ITEM_ID.play);
    const playButton = document.getElementById(PLAY_BUTTON_ID);

    if (!playNav || !playButton) {
      return;
    }

    playNav.classList.add(highlightedStyles);
    playButton.style.zIndex = '8';
    const playNavRect = playNav.getBoundingClientRect();
    const playButtonRect = playButton.getBoundingClientRect();

    const playButtonPopupLeft = playButtonRect.left - playButtonRect.width - 20;
    const playNavTutorialWidth = playNavRect.width + 280;

    const arrow = playButtonPopupLeft - playNavTutorialWidth > 50 ? 'right' : 'top';

    setContent(
      <>
        {createPopup(t('web-tutorial.play-nav'), playNav, 'left')}
        {createPopup(t('web-tutorial.play-button'), playButton, arrow)}
      </>
    );
  };

  const draw = useEvent(() => {
    if (step === 1) {
      drawFirstStep();
    }
    if (step === 2) {
      drawSecondStep();
    }
    if (step === 3) {
      drawThirdStep();
    }
  });

  useEffect(draw, [step]);
  useVisualViewportResize(draw);

  useEffect(() => {
    return () => {
      document.getElementById(NAVIGATION_BAR_ITEM_ID.challenges)?.classList.remove(highlightedStyles);
      document.getElementById(NAVIGATION_BAR_ITEM_ID.learn)?.classList.remove(highlightedStyles);
      document.getElementById(NAVIGATION_BAR_ITEM_ID.ranking)?.classList.remove(highlightedStyles);
      document.getElementById(NAVIGATION_BAR_ITEM_ID.play)?.classList.remove(highlightedStyles);
    };
  }, []);

  return content;
};

export default DesktopTutorial;
